import { Faq, FaqService } from '..';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { FaqCategoryService } from '@app/_components/faq-category/faq-category.service';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class FaqComponent implements OnInit {
	faqSectionId: any;
	faqCategoryId: any;
	faqCategory: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private faqCategoryService: FaqCategoryService,
		private faqService: FaqService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.faq = data.faq,
			this.faqSectionId = data.faqSectionId,
			this.faqCategoryId = data.faqCategoryId,
			this.statuses = faqService.statuses;
	}

	@Input() faq: Faq;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	faqId: number;
	faqForSpecificSection: Faq;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'faqId': [],
		questionDesc: [
			{ type: 'required', message: 'Required' }
		],
		answerDesc: [],
		displayOrder: [],
		enabled: [],
		description: [],
		opsNotes: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole faq object
		if (this.faq) {
			this.formById();
			this.faqId = this.faq.faqId;
			this.fixDates();
			this.form1.patchValue(this.faq);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.faqId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.faqService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faq = res.data.faq;
						this.doAdd.emit(this.faq);
					},
					(err: any) => {
						console.log('faq-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formAddSpecificFaqSection(faqSectionId: any) {
		try {
			this.faqForSpecificSection = this.faq;
			this.faqForSpecificSection.faqSectionId = faqSectionId;
			this.faqForSpecificSection.faqId = null;
			console.log('property-add post: ' + JSON.stringify(this.faq));
			this.formLoading = true;
			this.faqService.add(this.faqForSpecificSection)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('faq-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('faq: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.faqService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faq = res.data.faq;
						this.doUpdate.emit(this.faq);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.faqService.delete(this.faq.faqId)
				.subscribe(
					(res: any) => {
						console.log('faq-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.faq);
					},
					(err: any) => {
						console.log('faq-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			faqId: [this.faqId],
			faqSectionId: [this.faqSectionId],
			questionDesc: ['', Validators.required],
			answerDesc: [],
			displayOrder: [],
			enabled: [true],
			description: [],
			opsNotes: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.faq.faqDate = moment(this.faq.faqDate).toDate();
	}

	onChangeReAssignFaq(faqSection: any){
		console.log('faqCategory-get SUCCESS: ' + faqSection);
		this.formAddSpecificFaqSection(faqSection.itemValue.faqSectionId);
	}

	formById() {
		try {
			this.faqCategoryService.findById(this.faqCategoryId)
				.subscribe(
					(res: any) => {
						console.log('faqCategory-get SUCCESS: ' + JSON.stringify(res));
						this.faqCategory = res.data.faqCategory;
					},
					(err: any) => {
						console.log('faqCategory-get FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}
}
